import React from "react";
import Layout from "src/components/layout/website/Layout";

const TermsPage: React.FC = () => {
  return (
    <Layout>
      <div className="min-h-screen bg-white py-16 px-6 max-w-5xl mx-auto">
        <h1 className="text-3xl font-bold text-indigo-600 mb-6">
          Terms & Conditions
        </h1>
        <p className="text-gray-600 mb-4">
          By accessing and using Invyntra, you agree to the following terms:
        </p>
        <ul className="list-disc ml-6 text-gray-600 space-y-2">
          <li>
            Use of the platform is governed by applicable laws and fair use
            policies.
          </li>
          <li>
            Users are responsible for maintaining the confidentiality of their
            login credentials.
          </li>
          <li>
            Invyntra reserves the right to update features or pricing with prior
            notice.
          </li>
          <li>
            Data shared within the platform remains confidential and secured.
          </li>
        </ul>
        <p className="text-gray-600 mt-6">
          For any queries about our terms, contact{" "}
          <span className="text-indigo-600">support@invyntra.com</span>.
        </p>
      </div>
    </Layout>
  );
};

export default TermsPage;
